import React, { useState } from "react";
import { MdEditNote, MdOutlineMessage } from "react-icons/md";
import useAttendance from "../../../hooks/useAttendance";
import moment from "moment";
import { useAuthContext } from "../../../context/AuthContext";
import { checkHrteachers } from "../../../util/checkPermissions";
import { useUIContext } from "../../../context/UIContext";
import { useTranslation } from "react-i18next";

function AttendanceTable({
  rows,
  dates,
  idsForKey,
  attendanceRecord = [],
  setIsUpLoading,
  schoolId,
  refetchData,
  setAttendanceRecord,
  saveAttendance,
  setSaveAttendance,
  hrTeachersData,
  schoolYearPeriodData,
  schoolYearId,
}) {
  const { t, i18n } = useTranslation();

  const [isSaving, setIsSaving] = useState([
    false,
    false,
    false,
    false,
    false,
    false,
    false,
  ]);

  const { createAttendance, updateAttendance } = useAttendance();

  const { handleToastCenterTop } = useUIContext();
  const { hasPermission } = useAuthContext();

  const DayAndDate = ({ day, number, date, onAllPresent }) => {
    let dayNum;
    if (number === 6) {
      dayNum = 0;
    } else {
      dayNum = number + 1;
    }

    return (
      <th className="p-1 pb-0">
        <button
          className="btn btn-outline-primary btn-sm m-0"
          id={date}
          name={dayNum}
          onClick={handleAllPresent}
        >
          {t("teacher.attendance.allPresent") || "전체출석"}
        </button>
        <br />
        <button
          className="btn btn-outline-secondary btn-sm m-0 mt-1 mb-1"
          id={date}
          name={dayNum}
          onClick={handleAllClear}
        >
          {t("teacher.attendance.allClear") || "전체해제"}
        </button>
        <br />
        {day}
        <br />
        <span>{date && date.slice(-5)}</span>
        <br />
        <button
          className="btn btn-primary btn-sm"
          name={dayNum}
          onClick={handleClick}
        >
          {isSaving[dayNum]
            ? t("common.labels.complete") || "완료"
            : t("common.labels.save") || "저장"}
        </button>
      </th>
    );
  };

  const handleAllPresent = (e) => {
    const dayNum = e.target.name;
    const dateToSave = e.target.id;
    // 기존 자료에서 일치하는 것이 있으면 업데이트 하고, 없으면
    const newRecords = rows.map((student) => {
      const filtered = attendanceRecord.find((r) => {
        const date = new Date(r.date).getDay();
        return (
          r.username === student.username &&
          date.toString() === dayNum.toString()
        );
      });
      return {
        id: filtered ? filtered.id : "",
        username: student.username,
        date: moment(dateToSave).format("YYYY-MM-DD"),
        attendance_status: "출석",
        schoolid: schoolId,
      };
    });

    setAttendanceRecord((prevData) => {
      const updatedData = [...prevData];

      newRecords.forEach((newRecord) => {
        // console.log("newRecord", newRecord);
        const index = updatedData.findIndex((record) => {
          const recordDate = moment(record.date).format("YYYY-MM-DD");
          return (
            record.username === newRecord.username &&
            recordDate === newRecord.date
          );
        });

        if (index !== -1) {
          updatedData[index] = newRecord;
        } else {
          updatedData.push(newRecord);
        }
      });

      return updatedData;
    });

    setSaveAttendance((prevData) => {
      // day에 해당하는 데이터 배열 가져오기
      const dayData = prevData[dayNum] || [];

      const updatedDayData = newRecords.map((newRecord) => {
        // username이 일치하는 객체가 있는지 확인하고, 있다면 업데이트하기
        const index = dayData.findIndex(
          (item) => item.username === newRecord.username
        );
        if (index !== -1) {
          // username이 일치하는 객체가 있다면, newRecord로 업데이트하기
          return newRecord;
        } else {
          // username이 일치하는 객체가 없다면, newRecord 그대로 반환하기
          return newRecord;
        }
      });

      return {
        ...prevData,
        [dayNum]: updatedDayData,
      };
    });

    // console.log("saveAttendance all", saveAttendance);
  };

  const handleAllClear = (e) => {
    const dayNum = e.target.name;
    const dateToSave = e.target.id;
    // 기존 자료에서 일치하는 것이 있으면 업데이트 하고, 없으면 새로 추가
    const newRecords = rows.map((student) => {
      const filtered = attendanceRecord.find((r) => {
        const date = new Date(r.date).getDay();
        return (
          r.username === student.username &&
          date.toString() === dayNum.toString()
        );
      });
      return {
        id: filtered ? filtered.id : "",
        username: student.username,
        date: moment(dateToSave).format("YYYY-MM-DD"),
        attendance_status: "",
        schoolid: schoolId,
      };
    });

    setAttendanceRecord((prevData) => {
      const updatedData = [...prevData];

      newRecords.forEach((newRecord) => {
        const index = updatedData.findIndex((record) => {
          const recordDate = moment(record.date).format("YYYY-MM-DD");
          return (
            record.username === newRecord.username &&
            recordDate === newRecord.date
          );
        });

        if (index !== -1) {
          updatedData[index] = newRecord;
        } else {
          updatedData.push(newRecord);
        }
      });

      return updatedData;
    });

    setSaveAttendance((prevData) => {
      const dayData = prevData[dayNum] || [];

      const updatedDayData = newRecords.map((newRecord) => {
        const index = dayData.findIndex(
          (item) => item.username === newRecord.username
        );
        if (index !== -1) {
          return newRecord;
        } else {
          return newRecord;
        }
      });

      return {
        ...prevData,
        [dayNum]: updatedDayData,
      };
    });
  };

  const handleChange = (e, username, day) => {
    const id = e.target.id;
    const status = e.target.value;
    const date = e.target.name;

    const newData = {
      schoolid: schoolId,
      username,
      date: moment(date).format("YYYY-MM-DD"),
      attendance_status: status,
      id: Number(id),
    };

    setAttendanceRecord((prevData) => {
      // 'username'과 'date'가 일치하는 레코드를 찾습니다.
      const index = prevData.findIndex((record) => {
        const recordDate = new Date(record.date).toLocaleDateString("sv-SE");
        return record.username === username && recordDate === date;
      });

      if (index !== -1) {
        // 레코드가 존재하면 그 레코드를 업데이트합니다.
        // 단, id는 유지하고, 다른 필드만 업데이트합니다.
        return prevData.map((record, i) =>
          i === index ? { ...record, ...newData, id: record.id } : record
        );
      } else {
        // 레코드가 존재하지 않으면 새 레코드를 추가합니다.
        return [...prevData, newData];
      }
    });

    // console.log("AttendanceRecord", attendanceRecord);

    setSaveAttendance((prevData) => {
      // day에 해당하는 데이터 배열 가져오기
      const dayData = prevData[day] || [];

      // username이 일치하는 객체가 있는지 확인하고, 있다면 업데이트하기
      const updatedDayData = dayData.map((item) =>
        item.username === username ? newData : item
      );

      // username이 일치하는 객체가 없다면, newData 추가하기
      if (!updatedDayData.find((item) => item.username === username)) {
        updatedDayData.push(newData);
      }

      return {
        ...prevData,
        [day]: updatedDayData,
      };
    });

    // console.log("saveAttendance change", saveAttendance);
  };

  // 학년도 날짜 범위 검증 함수
  const isDateInSchoolYearRange = (dateToCheck) => {
    if (!schoolYearPeriodData || !schoolYearId) return true;

    const filteredPeriod = schoolYearPeriodData.filter(
      (r) => r.school_year_id.toString() === schoolYearId.toString()
    );

    if (filteredPeriod.length === 0) return true;

    const periodData = filteredPeriod[0];
    if (!periodData.start_date || !periodData.end_date) return true;

    const checkDate = new Date(dateToCheck);
    const startDate = new Date(periodData.start_date);
    const endDate = new Date(periodData.end_date);

    return checkDate >= startDate && checkDate <= endDate;
  };

  const handleClick = (e) => {
    const dayNum = e.target.name;
    // console.log("saveAttendance[dayNum]", saveAttendance[dayNum]);
    if (saveAttendance[dayNum] === undefined) {
      handleToastCenterTop(
        t("common.messages.noChange") || "변동된 데이터가 없습니다."
      );
      return;
    }

    // 학년도 날짜 범위 검증
    const dateToSave = saveAttendance[dayNum][0]?.date;
    if (dateToSave && !isDateInSchoolYearRange(dateToSave)) {
      handleToastCenterTop(
        t("teacher.attendance.dateNotInSchoolYear") ||
          "선택한 학년도에 속하지 않은 날짜입니다. 올바른 날짜를 선택해 주세요."
      );
      return;
    }

    if (
      rows &&
      rows.length > 0 &&
      !hasPermission(
        null,
        "can_create",
        checkHrteachers(
          hrTeachersData,
          saveAttendance[dayNum][0].username,
          rows[0].school_year
        )
      )
    ) {
      handleToastCenterTop(
        t("common.messages.homeroomTeacherOnly") ||
          "학생의 담임과 권한이 있는 사람만 저장할 수 있습니다."
      );
      return;
    }

    createAttendance.mutate(saveAttendance[dayNum], {
      onSuccess: () => {
        refetchData();
        setIsUpLoading(false);
        setIsSaving((prev) => {
          const copy = [...prev];
          copy[Number(dayNum)] = true;
          return copy;
        });
        setTimeout(() => {
          setIsSaving((prev) => {
            const copy = [...prev];
            copy[Number(dayNum)] = false;
            return copy;
          });
        }, 2000);
      },
      onError: (error) => {
        setIsUpLoading(false);
        console.error(error); // 일단 콘솔에 에러를 출력합니다.
        console.error("위와 같은 에러가 났으니 고치삼");
        alert(t("common.messages.errorAlert") + error);
      },
    });
  };

  const handleMemo = (id, memo, previousMemo) => {
    const newData = {
      memo,
      id: Number(id),
    };

    // console.log("newData", newData);
    if (memo !== null) {
      updateAttendance.mutate(newData, {
        onSuccess: () => {
          refetchData();
          setIsUpLoading(false);
        },
        onError: (error) => {
          setIsUpLoading(false);
          console.error(error); // 일단 콘솔에 에러를 출력합니다.
          console.error("위와 같은 에러가 났으니 고치삼");
          alert(t("common.messages.errorAlert") + error);
        },
      });
    }
  };

  return (
    <table className="table border text-center" style={{ minWidth: "700px" }}>
      <thead>
        <tr>
          {idsForKey &&
            Object.keys(idsForKey).map((item) => {
              if (item === "0") return null;
              return <th key={item}>{idsForKey[item][0]}</th>;
            })}
          <th>
            <span className="d-block mb-2 text-end">
              {String(dates[0]).slice(0, 5)}
            </span>
            {t("common.user.fullname") || "이름"}
          </th>

          {i18n.language === "en"
            ? ["Mon", "Tue", "Wed", "Thu", "Fri", "Sat", "Sun"].map(
                (day, i) => (
                  <DayAndDate
                    key={i}
                    day={day}
                    number={i}
                    date={dates[i]}
                    onAllPresent={() => handleAllPresent(i)}
                  />
                )
              )
            : ["월", "화", "수", "목", "금", "토", "일"].map((day, i) => (
                <DayAndDate
                  key={i}
                  day={day}
                  number={i}
                  date={dates[i]}
                  onAllPresent={() => handleAllPresent(i)}
                />
              ))}
        </tr>
      </thead>
      <tbody>
        {rows &&
          rows.map((student, index) => (
            <tr key={index}>
              {Object.keys(idsForKey).map((item, itemIndex) => {
                if (item === "0") return null;
                return <td key={`${index}-${itemIndex}`}>{student[item]}</td>;
              })}
              <td className="align-middle">{student.fullname}</td>
              {[1, 2, 3, 4, 5, 6, 0].map((day, i) => {
                const filtered = attendanceRecord.find((r) => {
                  const date = new Date(r.date).getDay();
                  return r.username === student.username && date === day;
                });
                return (
                  <td className="text-end" key={i}>
                    <div className="d-flex justify-content-center">
                      <div>
                        <select
                          key={filtered ? filtered.id : ""}
                          value={filtered ? filtered.attendance_status : ""}
                          className="form-control m-0 p-0"
                          style={
                            filtered?.attendance_status === "출석"
                              ? { backgroundColor: "#E3F2FD" }
                              : filtered?.attendance_status !== "" &&
                                filtered?.attendance_status !== undefined
                              ? { backgroundColor: "#FFF8E1" }
                              : {}
                          }
                          name={dates[i]}
                          id={filtered ? filtered.id : ""}
                          onChange={(e) =>
                            handleChange(e, student.username, day)
                          }
                        >
                          <option value="">
                            {t("common.labels.select") || "선택"}
                          </option>
                          <option value="출석">
                            {t("teacher.attendance.attendance") || "출석"}
                          </option>
                          <option value="질결">
                            {t("teacher.attendance.sickAbsence") || "질결"}
                          </option>
                          <option value="무결">
                            {t("teacher.attendance.justAbsence") || "무결"}
                          </option>
                          <option value="기결">
                            {t("teacher.attendance.etcAbsence") || "기결"}
                          </option>
                          <option value="질지">
                            {t("teacher.attendance.sickTardiness") || "질지"}
                          </option>
                          <option value="무지">
                            {t("teacher.attendance.justTardiness") || "무지"}
                          </option>
                          <option value="기지">
                            {t("teacher.attendance.etcTardiness") || "기지"}
                          </option>
                          <option value="질조">
                            {t("teacher.attendance.sickLeave") || "질조"}
                          </option>
                          <option value="무조">
                            {t("teacher.attendance.justLeave") || "무조"}
                          </option>
                          <option value="기조">
                            {t("teacher.attendance.etcLeave") || "기조"}
                          </option>
                          <option value="질결과">
                            {t("teacher.attendance.sickNoClass") || "질결과"}
                          </option>
                          <option value="무결과">
                            {t("teacher.attendance.justNoClass") || "무결과"}
                          </option>
                          <option value="기결과">
                            {t("teacher.attendance.etcNoClass") || "기결과"}
                          </option>
                          <option value="출인결">
                            {t("teacher.attendance.noAbsence") || "출인결"}
                          </option>
                          <option value="출인지">
                            {t("teacher.attendance.noTardiness") || "출인지"}
                          </option>
                          <option value="출인조">
                            {t("teacher.attendance.noLeave") || "출인조"}
                          </option>
                          <option value="출인결과">
                            {t("teacher.attendance.noNoClass") || "출인결과"}
                          </option>
                        </select>
                      </div>
                      <div>
                        {filtered?.memo ? (
                          <MdOutlineMessage
                            size={22}
                            className="ms-1"
                            title={
                              filtered && filtered.memo
                                ? filtered.memo
                                : t("teacher.attendance.noMemo") || "메모 없음"
                            }
                            onClick={() => {
                              if (filtered && filtered.id) {
                                const previousMemo = filtered.memo
                                  ? filtered.memo
                                  : "";
                                const memo = prompt(
                                  t("teacher.attendance.insertMemo") ||
                                    "메모를 입력하세요",
                                  previousMemo
                                );
                                handleMemo(filtered.id, memo, previousMemo);
                              } else {
                                alert(
                                  t("teacher.attendance.afterSavingMemo") ||
                                    "출석상태 저장 후 메모 기록할 수 있어요."
                                );
                              }
                            }}
                          />
                        ) : (
                          <MdEditNote
                            className="ms-1"
                            size={22}
                            title={
                              filtered && filtered.memo
                                ? filtered.memo
                                : t("teacher.attendance.noMemo") || "메모 없음"
                            }
                            onClick={() => {
                              if (filtered && filtered.id) {
                                const previousMemo = filtered.memo
                                  ? filtered.memo
                                  : "";
                                const memo = prompt(
                                  t("teacher.attendance.insertMemo") ||
                                    "메모를 입력하세요",
                                  previousMemo
                                );
                                handleMemo(filtered.id, memo, previousMemo);
                              } else {
                                alert(
                                  t("teacher.attendance.afterSavingMemo") ||
                                    "출석상태 저장 후 메모 기록할 수 있어요."
                                );
                              }
                            }}
                          />
                        )}
                      </div>
                    </div>
                  </td>
                );
              })}
            </tr>
          ))}
      </tbody>
    </table>
  );
}

export default AttendanceTable;

/* 
                자... 이게 create과 save만 하면 된다. 생각해 보자.
                필요한 정보는 schoolid, username, date, attendance_status
                근데 메모는 따로 저장하니까 별도로 하고
                메모를 먼저 저장해 버릴 수도 있겠군... 메모를 저장하든, status를 저장하든 먼저 저장된 것이 있으면 update를 해야한다.
               그리고 일 단위로 저장한다.
               그렇다면... 저장을 누르면, 해당 일의 기록을 싹 가져와서 저장해야겠군.
               상태를 변경하거나 메모를 쓰면 아래와 같은 구조로 요일별로 저장하고, 저장 누를 때
               해당 요일의 해당하는 번호를 찾아서 그 번호에 있는 [{}]를 저장으로 보내주면 된다.
               ㅇㅋ. 해보자! 밥먹고!
{
  "0": [
    {
      username: "",
      date: "",
      attendance_status: ""
    },
    // ...
  ],
  "1": [
    {
      username: "",
      date: "",
      attendance_status: ""
    },
    // ...
  ]
}
                */
